<template>
    <DatePicker         
        v-on:input="$emit('input', $event)"
        :value="value"
        :input-class="custonClass"      
        format="DD/MM/YYYY" 
        value-type="DD/MM/YYYY"
        lang="pt-br" 
        placeholder="Informe a data"
        :disabled="disabled">
        <template v-slot:header="{ emit }">
            <button class="mx-btn mx-btn-text" @click="emit(new Date())">Hoje</button>
        </template>
    </DatePicker>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/pt-br';

export default {
    name: 'inputData',

    components: {
        DatePicker
    },
    props:{
        value : {
           typeof: Date,
           required: true
        },
        custonClass:{
            typeof: String,
            required: false,
            default: 'form-control'
        },
        disabled: {
            typeof: Boolean,
            require: false,
            default: false
        }
    }
}
</Script>